module.exports = __webpack_public_path__ + "img/black-draganddrop.9f443c90.svg";